import { handleMessageEmit } from '@/methods/message/handleMessageEmit'

import { WS_EVENT_ROOM, WS_EVENT_ROOM_STATES } from '@/constants/socketEvent'

export const getRoomSocketInfo = ({ socket }: any) => {
  const infoContent = {
    sid: WS_EVENT_ROOM.sid,
    ssid: WS_EVENT_ROOM.state,
    body: [{ key: WS_EVENT_ROOM_STATES.all, value: 0 }],
  }

  handleMessageEmit({ socket, content: infoContent })
}
